import { render, staticRenderFns } from "./NoteButton.vue?vue&type=template&id=3ea03543"
import script from "./NoteButton.vue?vue&type=script&lang=ts"
export * from "./NoteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports